import { Alert, Space, Spin } from 'antd';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ToastVariant } from '../../../../../components/Toast/toast.model';
import { toastService } from '../../../../../components/Toast/toast.service';
import { onLogDeleteAccount } from '../../../../../events/hooks/onLogDeleteAccount.hook';
import { App } from '../../../../App/App';
import { AppRoutes } from '../../../../Routing/routing.model';

import { deleteUser } from './hooks/useDeleteUser.hook';

interface Props {
  uid: string;
}

export const ConfirmDeleteAccount: React.FC<Props> = ({ uid }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  const [deleteUserMessage, setDeleteUserMessage] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    const handleDeleteAccount = async () => {
      setIsLoading(true);

      const [response, respError] = await deleteUser(uid);
      setDeleteUserMessage(response);
      setError(respError);
      if (!respError) {
        onLogDeleteAccount(uid);
        toastService.show(t('DELETED_ACCOUNT_TOAST'), ToastVariant.SUCCESS);
      } else if (respError) {
        toastService.show(t('ERROR_DESCRIPTION'), t('ERROR'), { variant: ToastVariant.ERROR });
      }
      setIsLoading(false);
      window.location.href = AppRoutes.HOME;
    };

    handleDeleteAccount();
  }, [uid, history]);

  return (
    <App>
      <Space direction="vertical" style={{ width: '100%', marginTop: '100px', marginBottom: '60%', padding: '50px' }}>
        {!error ? (
          <Alert
            showIcon
            message={
              <span>
                {t('DO_NOT_LEAVE_PAGE_MESSAGE')}
                {isLoading ? <Spin /> : null}
              </span>
            }
            description={t('DO_NOT_LEAVE_PAGE_DESCRIPTION')}
            type="warning"
          />
        ) : (
          <Alert showIcon message={t('ERROR')} description={deleteUserMessage} type="error" />
        )}
      </Space>
    </App>
  );
};
